module.exports = __webpack_public_path__ + "static/luvstay2-15216f5ba72b7aa5d99c2546ad1b6c88.png";